import React, { useEffect, useMemo } from 'react';

import { SmButton } from '@smiles/smiles-react-design-system';
import Mustache from 'mustache';
import { TScreens } from '@/containers/Modal';

import useApi from '@/hooks/useApi';
import useEvent from '@/hooks/useEvent';

import { TVoucherItem } from '@/services/requests/Voucher/types';
import { TModalContent } from '@/services/requests/Liferay/types';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';

import { getUuid } from '@/helpers/StringHelper/uuid';

import { VoucherCard } from './VoucherCard';

type TProps = {
  onBack: () => void;
  liferayContent: TModalContent;
  voucherList: TVoucherItem[];
  setChangeVoucher: (voucherNumber: string) => void;
  changeScreen: (newScreen: TScreens) => void;
};

export function VoucherList({
  onBack,
  liferayContent,
  voucherList,
  setChangeVoucher,
  changeScreen,
}: TProps) {
  useEffect(() => {
    if (voucherList.length < 1) {
      changeScreen('error');
    }
  }, [voucherList, changeScreen]);
  const liferayFilled = useMemo<TModalContent>(() => {
    return JSON.parse(
      Mustache.render(JSON.stringify(liferayContent), voucherList),
    );
  }, [liferayContent, voucherList]);

  const { ApiInteractions } = useApi();
  const event = useEvent();

  const handleBack = (): void => {
    dispatchInteraction(
      ApiInteractions,
      'extra_mpv_select_voucher_click_back',
      {
        recommendationId: event.data.recommendationId,
      },
    );
    onBack();
  };

  return (
    <div className="smls-b2c-modals__modal-content">
      <div className="smls-b2c-modals__button--back">
        <SmButton
          onClick={handleBack}
          isPill
          isOutlined
          icon={<span className="material-icons">arrow_back_ios</span>}
        />
      </div>
      <div className="smls-b2c-modals__voucherlist">
        {liferayFilled.title?.text && (
          <span
            className="smls-b2c-modals__title" // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: liferayFilled.title.text,
            }}
          />
        )}
        {liferayFilled.description?.text && (
          <span
            className="smls-b2c-modals__description" // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: liferayFilled.description.text,
            }}
          />
        )}
        <div className="smls-b2c-modals__scroll_content">
          {voucherList.map(card => (
            <VoucherCard
              cardData={card}
              key={getUuid()}
              liferayContent={liferayContent}
              setChangeVoucher={setChangeVoucher}
              changeScreen={changeScreen}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
